import { HermesAnalytics } from '@workivate/tho-web-shared';

export const AnalyticsEvent = HermesAnalytics.AnalyticsEventsFactory({
  measurementId: window.WAM.ENV.analyticsMeasurementId || '',
  debug: !IS_PRODUCTION,
  gtag: typeof window !== 'undefined' ? window.gtag : undefined,
});
